import React from "react";
import PropTypes from "prop-types";
import { getDocumentFieldName } from "../../api/engineerApi";
import { SignedImage } from "../common/SignedImage";

function ViewStandardDocument({ userProfile, documentType, title = "" }) {
  const documentFieldName = getDocumentFieldName(documentType);
  const documentExists = userProfile[documentFieldName] ? true : false;

  return (
    <div className="row">
      <div className="col-xs-12 col-md-6 d-flex flex-column align-items-center">
        <p className="text-muted mb-0">{title}</p>
        {documentExists ? (
          <SignedImage
            className="mb-3"
            src={userProfile[documentFieldName].url}
            style={{ width: 200, maxWidth: "100%", height: undefined }}
          />
        ) : (
          <p>No document uploaded</p>
        )}
      </div>
    </div>
  );
}

ViewStandardDocument.propTypes = {
  userProfile: PropTypes.object.isRequired,
  documentType: PropTypes.string.isRequired,
  title: PropTypes.string,
};

export default ViewStandardDocument;
